import { useQuery } from '@tanstack/react-query';

import { getUnreadClinicMessages } from 'app/services/clinic';

export const getUnreadClinicMessagesKey = (clinicId) => ['clinics', clinicId, 'messages'];

export default function useUnreadClinicMessages(clinicId) {
  return useQuery({
    queryKey: getUnreadClinicMessagesKey(clinicId),
    queryFn: () => getUnreadClinicMessages(clinicId),
    refetchOnWindowFocus: false,
    enabled: Boolean(clinicId),
  });
}
